import { getLocale } from '@/utils/locale'
import Cookies from 'js-cookie'

export function getBaseUrl() {
  var selectedlocale = getLocale()
  if (selectedlocale === undefined || selectedlocale == null) {
    selectedlocale = process.env.VUE_APP_I18N_LOCALE
  }
  const url_domain = localStorage.getItem('olselforder_url_domain') || Cookies.get('olselforder_url_domain')
  const baseURL = '/' + selectedlocale + '/' + url_domain
  // const baseURL = '/' + url_domain
  return baseURL
}

export function getParameter() {
  const url_store = localStorage.getItem('olselforder_selected_url_id')
  let parameter = {}
  if (url_store) {
    parameter = {
      url_id: url_store
    }
  }
  // return process.env.NODE_ENV === 'development' ? {} : parameter
  return parameter
}
